<template>
  <div class="time-header d-flex" :class="{ 'drag-active': isDragging }">
    <div class="time-slots d-flex" style="gap: 5px">
      <div
        v-for="(slot, index) in reversedAnticipationSlots"
        :key="slot.id"
        class="time-slot text-center text-uppercase rounded-lg pa-1"
        :class="{
          'highlighted secondary white--text': isHighlighted(index),
          'grey lighten-3': !isHighlighted(index)
        }"
        :title="getSlotTooltip(slot)"
        :style="{ fontSize: fontSize }"
      >
        {{ formatSlotLabel(slot) }}
      </div>
    </div>
    <div class="time-header-controls-spacer"></div>
  </div>
</template>

<script>
export default {
  name: "a-pricing-strategy-grid-rules-grid-header",
  props: {
    anticipationSlots: {
      type: Array,
      required: true
    },
    isDragging: {
      type: Boolean,
      default: false
    },
    highlightedColumnIndices: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    fontSize() {
      return this.reversedAnticipationSlots.length > 10 ? "10px" : "12px";
    },
    reversedAnticipationSlots() {
      return [...this.anticipationSlots];
    }
  },
  methods: {
    isHighlighted(index) {
      return this.isDragging && this.highlightedColumnIndices.includes(index);
    },
    formatSlotLabel(slot) {
      if (slot.from === slot.to) {
        if (slot.from === 0) {
          return this.$t("grid_same_day"); // 0-0 = mismo día
        } else if (slot.from === 1) {
          return this.$t("grid_day_before"); // 1-1 = día anterior
        } else {
          return this.$t("grid_days_before", { days: slot.from });
        }
      }
      /* return this.$t("grid_days_range_before", {
        from: slot.from,
        to: slot.to
      }); */
      return slot.from + " - " + slot.to;
    },
    getSlotTooltip(slot) {
      if (slot.from === slot.to) {
        if (slot.from === 0) {
          return this.$t("grid_tooltip_same_day");
        } else if (slot.from === 1) {
          return this.$t("grid_tooltip_one_day_before");
        } else {
          return this.$t("grid_tooltip_days_before", { days: slot.from });
        }
      }
      return this.$t("grid_tooltip_days_range", {
        from: slot.from,
        to: slot.to
      });
    }
  }
};
</script>

<style scoped lang="scss">
.time-header {
  margin-bottom: 10px;
  padding: 0 10px;
  transition: all 0.3s ease;
}
.time-header-controls-spacer {
  width: 40px;
}
.time-slots {
  flex: 1;
}
.time-slot {
  flex: 1;
  transition: all 0.3s ease;
  &.highlighted {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);
  }
}
</style>
